import { createContext } from 'react';

export const authContext = createContext({});
export const AuthContextProvider = authContext.Provider;
export const AuthContextConsumer = authContext.Consumer;
